module.exports = __webpack_public_path__ + "static/resume-dadf03101348188e024fc3fe6e96f983.png";